import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "bootstrap/dist/css/bootstrap.min.css";
import "./About.css";
import profile from './profile.jpg'

export default function About() {
  return (
    <>
      <Container className="About-header">
        <Row>
          <Col xs={12} md={7} className="About-text">
            <h3>About me</h3>
            American front-end web developer living in France for over 11 years. Self-studied CSS, HTML and JavaScript from 2019 to 2021 before taking a certification workshop to consolidate my skill base.
            <br />
             <br />
            <h3>Education and experience</h3>
            Certified <a href="https://www.shecodes.io/certificates/c9211566f16710ee1963d4fa5611a568" className="Front-end-link">Front-end</a> and <a href="https://www.shecodes.io/certificates/3b9758bce49526369df1deff33030792" className="React-link">React</a> developer through SheCodes workshops. A certified English language teacher through the Univeristy o Cambridge. Studied international businees at Eastern Florida State University. 
            <br />
            <br />
            Currently working at Skillsoft Digital France as a <em>Senior Content Developer</em> and manage a team of content developers based in Paris and Dublin. Previously I worked as a <em>Service Manager</em> and teacher at the largest English language school in France. 


          </Col>
          <Col xs={6} md={5} className="About-image">
            <img src={profile} alt="coding" className="About-image " />
          </Col>
        </Row>
      </Container>
    </>
  );
}